import Vue from 'vue';
import Vuex from 'vuex';
// import { getCategory } from '../api';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    category:null,
    categoryOption:null,
  },
  mutations: {
    setCategory(state,category) {
      state.category = category
    },
    setCategoryOption(state,category) {
      state.categoryOption = category
    }
  },
  actions: {},
  modules: {
  },
});
